import { useMemo } from 'react';
import {
  canManageAccount,
  isWorkspaceOwner,
  type AccountMemberRole,
} from '@trove-shared';
import { useAuth } from '@/auth/AuthContext';

export function useAccountRole() {
  const { user } = useAuth();

  return useMemo(() => {
    const ctx = {
      uid: user?.id ?? '',
      auid: user?.auid,
      isAccountAdmin: user?.isAccountAdmin,
      isAccountOwner: user?.isAccountOwner,
    };
    const accountRole: AccountMemberRole = user?.accountRole ?? (canManageAccount(ctx) ? 'admin' : 'user');
    return {
      accountRole,
      canManageAccount: canManageAccount(ctx),
      isWorkspaceOwner: isWorkspaceOwner(ctx),
      loading: !user,
    };
  }, [user]);
}
